import { render, staticRenderFns } from "./MessagePushDialog.vue?vue&type=template&id=60e65a51&scoped=true&"
import script from "./MessagePushDialog.vue?vue&type=script&lang=js&"
export * from "./MessagePushDialog.vue?vue&type=script&lang=js&"
import style0 from "./MessagePushDialog.vue?vue&type=style&index=0&id=60e65a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e65a51",
  null
  
)

export default component.exports